export default __webpack_public_path__ + "5cc542b0c815638b3d61b896dc7aae11.jpg";